import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { SnackbarNotificationComponent } from "./components/snackbar-notification/snackbar-notification.component";
import { SnackbarComponent } from "./components/snackbar/snackbar.component";
import { SnackbarNotificationService } from "./services/snackbar-notification/snackbar-notification.service";

@NgModule({
  imports: [CommonModule, SnackbarNotificationComponent, SnackbarComponent],
  exports: [SnackbarNotificationComponent]
})
export class SnackbarNotificationModule {
  public static forRoot(): ModuleWithProviders<SnackbarNotificationModule> {
    return {
      ngModule: SnackbarNotificationModule,
      providers: [SnackbarNotificationService]
    };
  }
}
